import { render, staticRenderFns } from "./MyPrescribeWrite.vue?vue&type=template&id=4b39eb1e"
import script from "./MyPrescribeWrite.vue?vue&type=script&lang=js"
export * from "./MyPrescribeWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports